import { scrollToElement, getHeaderHeight, getDescHeaderHeight } from './scroll-to-element';

let description = document.querySelector('#detail-description');
let workSection;
let navBar = document.querySelector(".desc-navigation-wrapper");
let allHeaders;
let scrollingFromClick = false;
let viewportUpdateLines;
let middleUpdateLine;
const descHeader = document.querySelector('.desc-header');

export function waitForImagesLoad(selector) {
    const root = document.querySelector(selector);
    if (!root) return Promise.resolve();

    const nodeList = root.querySelectorAll('[loading="lazy"]');
    const images = [...nodeList];


    const promises = images.map(img => {
        return new Promise(resolve => {
            if (img.complete && img.naturalWidth !== 0) {
                resolve({ img, status: 'loaded' });
                return;
            }

            const onLoad = () => resolve({ img, status: 'loaded' });
            const onError = () => resolve({ img, status: 'error' });

            img.addEventListener('load', onLoad, { once: true });
            img.addEventListener('error', onError, { once: true });

            img.removeAttribute('loading');

            requestAnimationFrame(() => {
                if (img.complete && img.naturalWidth !== 0) {
                    resolve({ img, status: 'loaded' });
                }
            });
        });
    });

    return Promise.all(promises);
}

function getOffset() {
    return getHeaderHeight() + getDescHeaderHeight();
} 

function initRwdBottomBar() {
    const sentinel = document.querySelector('.buy-button');

    const observer = new IntersectionObserver((entries) => {

        entries.forEach((entry) => {
            if (!entry.isIntersecting && entry.boundingClientRect.y < getOffset()) {
                descHeader.classList.add("bottom-sticking");
            } else {
                descHeader.classList.remove("bottom-sticking");
            }
        });
    }, {
        rootMargin: `${-1 * getHeaderHeight()}px 0px 0px 0px`,
    });
    observer.observe(sentinel);
}

export default function () {
    workSection = document.querySelector("[data-desc-navigation]");
    if (!workSection) return;

    const moduleEnabled = Number(workSection.dataset.descNavigation);
    allHeaders = Array.from(document.querySelectorAll('.description-header')).filter(header => header.innerText.trim());
    if (!moduleEnabled || allHeaders.length < 2) return;

    createNavBar(); 
    initNavBarObserver();
    initRwdBottomBar();
    initNavButtons();
}

function createNavBar() {
    workSection.insertAdjacentHTML('afterbegin', `
        <div class="nav-sentinel"></div>
        <div class="desc-navigation-wrapper">
            <div class="desc-navigation"></div>
        </div>`);

    navBar = workSection.querySelector(".desc-navigation-wrapper");
    navBar.style.top = `${getOffset()}px`;
}
function initNavBarObserver() {
    const sentinel = document.querySelector('.nav-sentinel');

    const navBarObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting && entry.boundingClientRect.y < getOffset()) {
                navBar.classList.add("sticking");
            } else {
                navBar.classList.remove("sticking");
                setButtonColor(0);
            }
        });
    }, {
        rootMargin: `${-1 * getOffset()}px 0px 0px 0px`,
    });
    navBarObserver.observe(sentinel);
}

function initNavButtons() {
    allHeaders.forEach((header, index) => {

        const navButton = document.createElement("button");
        navButton.innerText = header.innerText;
        navButton.setAttribute("title", `Przewiń do - ${header.innerText}`);
        navBar.querySelector(".desc-navigation").appendChild(navButton);

        navButton.addEventListener("click", () => { buttonClickActions(header, index) });
        initColorChanging(header, index);
    });
}
function buttonClickActions(header, index) {
    scrollingFromClick = true;
    setButtonColor(index, true);

    waitForImagesLoad('#detail-description')
        .then(() => {
            scrollToElement(header, (navBar.clientHeight + 16), '', () => {
                scrollingFromClick = false;
            });
        });

}

function initColorChanging(singleHeader, index) {
    window.addEventListener("load", function () {

        let stickyOffset = (-1 * (getOffset() + navBar.clientHeight + singleHeader.clientHeight + getDescHeaderHeight()));

        viewportUpdateLines = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                setButtonColor(getLikelyHeaderIndex());
            });
        }, {
            rootMargin: `${stickyOffset}px 0px 0px 0px`,
        });

        middleUpdateLine = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                setButtonColor(getLikelyHeaderIndex());
            });
        }, {
            rootMargin: `${-0.5 * window.innerHeight}px 0px ${-0.5 * window.innerHeight}px 0px`,
        });


        viewportUpdateLines.observe(singleHeader);
        middleUpdateLine.observe(singleHeader);
    });
}

function getLikelyHeaderIndex() {
    let stickyOffset = getOffset() + navBar.clientHeight + getDescHeaderHeight();
    let likelyHeaderIndex;
    let previousSmallest = Infinity;

    allHeaders.forEach((header, index) => {
        const rect = header.getBoundingClientRect();

        const distanceToTop = Math.abs(rect.top - stickyOffset);
        const distanceToBottom = Math.abs(window.innerHeight - rect.bottom - stickyOffset);

        if (distanceToTop > distanceToBottom) return;

        if (distanceToTop < previousSmallest) {
            likelyHeaderIndex = index;
            previousSmallest = distanceToTop;
        }
    });

    return (likelyHeaderIndex ? likelyHeaderIndex : 0);
}
function setButtonColor(indexToColor, indexFromClick) {
    if (scrollingFromClick && !indexFromClick) return;

    let allButtons = navBar.querySelectorAll("button");
    const className = "highlighted";
    allButtons.forEach((button, index) => {

        button.classList.remove(className);
        if (index !== indexToColor) return;

        button.classList.add(className);

        scrollNavBar(button, scrollingFromClick);
    });
}


function scrollNavBar(button, scrollingFromClick) {
    if (scrollingFromClick) {
        button.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            container: "nearest"
        });

        return;
    }

    const container = navBar.querySelector(".desc-navigation");

    const containerLeft = container.scrollLeft;
    const containerRight = containerLeft + container.clientWidth;
    const buttonLeft = button.offsetLeft;
    const buttonRight = buttonLeft + button.clientWidth;

    let makeNextVisibleOffset = 70;

    if (buttonRight > containerRight) return container.scrollTo({
        left: buttonRight - container.clientWidth + makeNextVisibleOffset,
        behavior: "smooth"
    });

    if (buttonLeft < containerLeft) return container.scrollTo({
        left: buttonLeft - makeNextVisibleOffset,
        behavior: "smooth"
    });
}